<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-24 17:50:34
 * @FilePath: 
 * @Description: 统计首页
-->
<template>
  <div class="full_page">
    <div class="statistics_img_con">
      <img class="full_img" src="@/assets/images/micropointTopBg.png" />
    </div>
    <div class="c-p-20">
      <p class="c-p-tb-20 bold c-black">常用功能</p>
      <ul class="statistics_card_con">
        <li
          v-for="(item, index) in functionList"
          :key="index"
          @click="handleToStatisticsPage(item.url)"
        >
          <div class="func_img_con">
            <img
              class="full_img"
              :src="require('@/assets/report/report-' + (index + 1) + '.png')"
              alt=""
            />
          </div>
          <p class="c-ft-24">{{ item.name }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatisticsHome",
  props: {},
  data() {
    return {
      functionList: [
        { name: "业绩汇总", url: "TotalPerformance" },
        { name: "个人业绩", url: "SinglePerformance" },
        { name: "技师业绩", url: "JishiPerformance" },
        { name: "会员统计", url: "MemberStatistics" },
      ],
    };
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
    handleToStatisticsPage(url) {
      this.$router.push({
        name: url,
      });
    },
  },
};
</script>
<style scoped lang="scss">
.statistics_img_con {
  height: 200px;
}
.statistics_card_con {
  display: flex;
  flex-wrap: wrap;
  li {
    flex: 1;
    height: 150px;
    border: 1px solid #eee;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    &:nth-child(4n) {
      margin-right: 0;
    }
    .func_img_con {
      width: 50px;
      margin-bottom: 20px;
    }
  }
}
</style>
